import http from '../plugins/axios'

export const getAllWarehouseList = async (params) => {
  try {
    const response = await http.get(`/api/v2/warehouses`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createWarehouse = async (payload) => {
  try {
    const response = await http.post(`/api/v2/warehouses`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateWarehouse = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/warehouses/${id}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteWarehouse = async (id) => {
  try {
    const response = await http.delete(`/api/v2/warehouses/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}